module.exports = __webpack_public_path__ + "img/employers-request.8a89536f.jpg";